$(".youtube-thumb-subtitle").textfill( {maxFontPixels: 140 });
$(".youtube-thumb-main-title").textfill( {maxFontPixels: -1 });
